import request from '@/utils/request'

export function getSpecialServiceListApi(query) {
  return request({
    url: '/config-service/v1/special-service/special-service',
    method: 'get',
    params: query
  })
}

export function addSpecialServiceApi(payload) {
  return request({
    url: '/config-service/v1/special-service/special-service',
    method: 'post',
    data: payload
  })
}

export function updateSpecialServiceApi(payload) {
  return request({
    url: '/config-service/v1/special-service/special-service',
    method: 'put',
    data: payload
  })
}

export function deleteSpecialServiceApi(payload) {
  return request({
    url: '/config-service/v1/special-service/special-service',
    method: 'delete',
    data: payload
  })
}

export function getSpecialServiceTransApi(query) {
  return request({
    url: `/config-service/v1/special-service/special-service/transaction`,
    method: 'get',
    params: query
  })
}

export function getSpecialServiceDetailApi(id) {
  return request({
    url: `/config-service/v1/special-service/special-service/${id}`,
    method: 'get'
  })
}
